// Static data for Vacay with K travel website

export const destinations = [
  {
    id: '1',
    name: 'Maldives Paradise',
    description: 'Experience overwater bungalows and pristine beaches in the Indian Ocean',
    image: 'https://images.unsplash.com/photo-1551918120-9739cb430c6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzYwNjU4MTU1fDA&ixlib=rb-4.1.0&q=85',
    price: 4999,
    duration: '7 days / 6 nights',
    rating: 4.9
  },
  {
    id: '2',
    name: 'Bali Luxury Escape',
    description: 'Discover ancient temples, rice terraces, and world-class resorts',
    image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzYwNjU4MTU1fDA&ixlib=rb-4.1.0&q=85',
    price: 3299,
    duration: '5 days / 4 nights',
    rating: 4.8
  },
  {
    id: '3',
    name: 'Caribbean Dreams',
    description: 'Turquoise waters, white sand beaches, and ultimate relaxation',
    image: 'https://images.unsplash.com/photo-1603477849227-705c424d1d80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGJlYWNofGVufDB8fHx8MTc2MDUzMjU4MHww&ixlib=rb-4.1.0&q=85',
    price: 3799,
    duration: '6 days / 5 nights',
    rating: 4.9
  },
  {
    id: '4',
    name: 'Seychelles Sanctuary',
    description: 'Exclusive island retreats with unparalleled natural beauty',
    image: 'https://images.unsplash.com/photo-1535262412227-85541e910204?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMGJlYWNofGVufDB8fHx8MTc2MDUzMjU4MHww&ixlib=rb-4.1.0&q=85',
    price: 5499,
    duration: '8 days / 7 nights',
    rating: 5.0
  },
  {
    id: '5',
    name: 'Thailand Bliss',
    description: 'Exotic culture, stunning beaches, and luxurious spa retreats',
    image: 'https://images.unsplash.com/photo-1549294413-26f195200c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZXNvcnR8ZW58MHx8fHwxNzYwNjU4MTU1fDA&ixlib=rb-4.1.0&q=85',
    price: 2899,
    duration: '7 days / 6 nights',
    rating: 4.7
  },
  {
    id: '6',
    name: 'Fiji Islands',
    description: 'Remote tropical paradise with crystal-clear lagoons',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMGJlYWNofGVufDB8fHx8MTc2MDUzMjU4MHww&ixlib=rb-4.1.0&q=85',
    price: 4299,
    duration: '7 days / 6 nights',
    rating: 4.8
  }
];

export const packages = [
  {
    id: '1',
    name: 'Romantic Getaway',
    description: 'Perfect for couples seeking intimate tropical experiences',
    features: ['Private villa accommodations', 'Couples spa treatments', 'Candlelit beach dinners', 'Sunset cruises'],
    startingPrice: 3499,
    popular: true
  },
  {
    id: '2',
    name: 'Family Adventure',
    description: 'Create unforgettable memories with your loved ones',
    features: ['Family-friendly resorts', 'Kids activities & clubs', 'Water sports included', 'Flexible dining options'],
    startingPrice: 4999,
    popular: false
  },
  {
    id: '3',
    name: 'Luxury All-Inclusive',
    description: 'Ultimate indulgence with everything taken care of',
    features: ['5-star accommodations', 'Gourmet dining', 'Premium beverages', 'Exclusive excursions'],
    startingPrice: 6999,
    popular: true
  },
  {
    id: '4',
    name: 'Wellness Retreat',
    description: 'Rejuvenate your mind, body, and soul',
    features: ['Spa & wellness programs', 'Yoga & meditation', 'Healthy cuisine', 'Beach & nature activities'],
    startingPrice: 3999,
    popular: false
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Sarah Johnson',
    location: 'New York, USA',
    rating: 5,
    text: 'Our Maldives honeymoon was absolutely magical! Every detail was perfectly arranged, and the resort exceeded all expectations. Thank you for making our dream vacation a reality!',
    avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson&background=ef571b&color=fff'
  },
  {
    id: '2',
    name: 'Michael Chen',
    location: 'Singapore',
    rating: 5,
    text: 'The Bali luxury package was worth every penny. From private villas to exclusive tours, everything was first-class. The team\'s attention to detail is unmatched.',
    avatar: 'https://ui-avatars.com/api/?name=Michael+Chen&background=ce9b42&color=fff'
  },
  {
    id: '3',
    name: 'Emma Rodriguez',
    location: 'Madrid, Spain',
    rating: 5,
    text: 'Caribbean Dreams lived up to its name! The turquoise waters, pristine beaches, and luxury accommodations made this the best vacation we\'ve ever had. Highly recommended!',
    avatar: 'https://ui-avatars.com/api/?name=Emma+Rodriguez&background=5c856e&color=fff'
  }
];

export const aboutInfo = {
  title: 'Your Gateway to Paradise',
  description: 'For over 15 years, we\'ve been crafting extraordinary tropical experiences for discerning travelers. Our passion for luxury travel and commitment to personalized service has made us the preferred choice for those seeking unforgettable escapes to the world\'s most beautiful destinations.',
  stats: [
    { label: 'Happy Travelers', value: '50,000+' },
    { label: 'Destinations', value: '120+' },
    { label: 'Years Experience', value: '15+' },
    { label: 'Satisfaction Rate', value: '99%' }
  ]
};
